import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBg = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 640 480",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fillRule: "evenodd",
		strokeWidth: "1pt",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "#d62612",
				d: "M0 320h640v160H0z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M0 0h640v160H0z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#00966e",
				d: "M0 160h640v160H0z"
			})
		]
	})
});
export default SvgBg;
